export default __webpack_public_path__ + "static/media/man-with-cv.3002bb0a.svg";